<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li [ngbNavItem]="WorkEnvironmentTab.States" *abpPermission="PermissionConstants.canManageCrmSettings">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::CRM:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ng-container *ngComponentOutlet="crmSegmentDefinitionsMainComponent"></ng-container>
      </ng-template>
    </li>
    <li [ngbNavItem]="WorkEnvironmentTab.Status">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::WorkEnvironment:StatusManagement:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-state-definition-main />
      </ng-template>
    </li>
    <li [ngbNavItem]="WorkEnvironmentTab.Skills" *ngIf="canManageAgentSkills">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::WorkEnvironment:Skills:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-skill-main />
      </ng-template>
    </li>
    <li [ngbNavItem]="WorkEnvironmentTab.WrapUpCodes" *ngIf="canManageWrapUpCodes">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::WorkEnvironment:WrapupCodes:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-wrap-up-definition-main />
      </ng-template>
    </li>
    <li [ngbNavItem]="WorkEnvironmentTab.DeclineReasons" *ngIf="canManageDeclineReasons">
      <a ngbNavLink>
        <span class="ml-1">
          {{ 'Settings::WorkEnvironment:DeclineReasons:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <app-decline-reason-main />
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>
